import React from 'react';

const TABS = [
  { id: 1, label: 'Principal' },
  { id: 2, label: 'Configuración' },
];

const TabNavigation = ({ selectedTab, setSelectedTab }) => (
  <ul className="nav nav-tabs">
    {TABS.map(({ id, label }) => (
      <li className="nav-item" key={id}>
        <button
          type="button"
          className={`nav-link${selectedTab === id ? ' active' : ''}`}
          onClick={() => setSelectedTab(id)}
        >
          {label}
        </button>
      </li>
    ))}
  </ul>
);

export default TabNavigation;
